import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
export var Illustration = function(param) {
    var width = param.width, height = param.height, CarinaIllustration = param.CarinaIllustration, title = param.title;
    return CarinaIllustration ? _jsx(CarinaIllustration, {
        width: width,
        height: height,
        title: title
    }) : null;
};
